import React from 'react';
import { Text, View } from 'react-native';

import { badgeMeta } from '../constants/badges';

export function BadgeChips({ badges, compact }: { badges?: string[]; compact?: boolean }) {
  if (!badges?.length) {
    return null;
  }
  const shown = badges.map(badgeMeta).filter(Boolean) as { emoji: string; shortLabel: string }[];
  if (!shown.length) {
    return null;
  }
  return (
    <View className="ml-1 flex-row flex-wrap items-center gap-1">
      {shown.map((b, i) => (
        <View
          key={`${b.shortLabel}-${i}`}
          className={`flex-row items-center rounded-full border border-zinc-200 bg-zinc-50 px-1.5 dark:border-zinc-700 dark:bg-zinc-800 ${
            compact ? 'py-0' : 'py-0.5'
          }`}>
          <Text className="text-[10px]" style={{ lineHeight: 14 }}>
            {b.emoji}
          </Text>
          {!compact ? (
            <Text className="ml-0.5 text-[10px] font-semibold text-zinc-800 dark:text-zinc-200">
              {b.shortLabel}
            </Text>
          ) : null}
        </View>
      ))}
    </View>
  );
}
